import { render, staticRenderFns } from "./DiskusiKelas.vue?vue&type=template&id=05e788e9&scoped=true"
import script from "./DiskusiKelas.vue?vue&type=script&lang=js"
export * from "./DiskusiKelas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e788e9",
  null
  
)

export default component.exports